import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../../modules/infra/i18n';
import ReportBox from '../../components/ReportBox';
import Num from '../../../../common/Num';
import Money from '../../../../common/money';
import shapes from '../../../../../../images/shapes.svg';

const ProductsSold = ({ productsSold, averageProductSale }) => (
  <ReportBox title={t('reports:leaderboard.products_sold')} automationId="container:productsSold">
    <div className="u-text-center">
      <div className="c-report-stat c-report-stat--huge u-mv">
        <Num automationId="text:productsSold:Amount">{productsSold}</Num>
        <img className="u-vertical-align-8px u-ml" src={shapes} alt="" />
      </div>
      <div className="c-horizontal-divider" />
      <div className="c-report-label u-type--uppercase u-pt+ u-pb-">{t('reports:leaderboard.avg_product_sale')}</div>
      <div className="c-report-stat u-mb+">
        <Money automationId="text:productsSold:AverageSale">{averageProductSale}</Money>
      </div>
    </div>
  </ReportBox>
);
ProductsSold.propTypes = {
  productsSold: PropTypes.number,
  averageProductSale: PropTypes.number,
};
ProductsSold.defaultProps = {
  productsSold: 0,
  averageProductSale: 0,
};

export default ProductsSold;
